import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  FeatureList,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const PanoramaLed = () => {
  

  const features = [
    {
      title: '높은 시인성 확보',
      bullets: [
      {
        label: (
          <>LED 기반의 선명한 조명으로 야간, 악천후, 터널과 같은 저시야 환경에서도 운전자가 도로 라인을 확실히 인지함</>
        ),
      },
      ]
    },
    {
      title: '양 라인 동기화 점멸 기능',
      bullets: [
      {
        label: (
          <>중앙선과 도로 가장자리 라인의 LED 모듈이 서로 동기화되어 점멸하며, 이를 통해 운전자는 진행 방향 신호를 직관적으로 파악이 가능함</>
        ),
      },
      ]
    },
    {
      title: '도로 안전성 향상',
      bullets: [
      {
        label: (
          <>급커브, 공사 구간, 긴 터널 구간 등 사고 위험이 높은 장소에서 차량 속도 조절 및 안전 주행을 자연스럽게 유도함</>
        ),
      },
      ]
    },
    {
      title: '고내구성 설계',
      bullets: [
      {
        label: (
          <>외부 충격, 기후 변화, 습기, 진동에 강한 구조로 제작되어 장기간 안정적으로 운영하여 유지비용이 절감됨</>
        ),
      },
      ]
    },
    {
      title: '설치 유연성 및 유지관리 용이',
      bullets: [
      {
        label: (
          <>다양한 도로 및 터널 구조에 맞춰 라인 길이와 모듈 간격을 조정할 수 있으며, 모듈 단위 교체가 가능해 유지보수가 효율적임</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`파노라마 LED 시선유도등`}
        subtitle={`시야 확보가 어려운 환경에서 \n선명한 조명으로 운전자의 시선을 유도합니다`}
        backgroundImage="/images/products/traffic-safety/panorama-led.png"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '파노라마 LED 시선유도등' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={``}
        title={`파노라마 LED 시선유도등`}
        description={
          <>
            도로 공사 구간, 급커브, 어두운 터널 등 시야 확보가 어려운 환경에서 {' '}
            운전자와 보행자의 안전한 주행·보행을 돕기 위해 일정한 광도의 빛을 제공하는 시선 유도 시스템입니다.
            <br />
            <br />
            도로 중앙선 및 가장자리 라인에 설치된 복수의 유도등 모듈이 서로 동기화되어 점멸함으로써, {' '}
            운전자가 진행 방향을 더욱 명확하고 직관적으로 인지할 수 있습니다.
          </>
        }
        images={[
          '/images/products/traffic-safety/panorama-led.png',
          '/images/products/traffic-safety/panorama-led2.png',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <InfoSection title="설치 영상">
        <VideoBlock src="/videos/panoramaled-installation-video.mp4"/>
      </InfoSection>

      <ProductDetailNav
        category="traffic-safety"
        currentPath="/products/traffic-safety/panorama-led"
        listPath="/products/traffic-safety"
      />
    


      <CTASection />
    </>
  );
};

export default PanoramaLed;
